import React from 'react';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import { updateField, submitWorkflowQuestion } from '../../../../redux/actions/Findings';
import './style.sass';

const getActiveQuestion = (questions, question = questions[0]) => {
  // Return first unanswered question in questions array.
  if (!question.answered) {
    return question;
  }

  const selectedAnswer = question.answers.find(a => a.selected);

  // Return the last answered question if the last question has been answered
  // but the finding has still not closed or moved jurisdiction.
  if (!selectedAnswer || !selectedAnswer.next) {
    return question;
  }

  // For an answered question, retrieve the next question and repeat.
  const nextQuestion = questions.find(q => q.id === selectedAnswer.next);
  return getActiveQuestion(questions, nextQuestion);
};

/* eslint-disable react/prop-types */

const AnsweredQuestion = (question) => {
  const answer = question.answers.find(i => i.selected);

  return (
    <div className="question answered">
      <div className="questionRow active">
        <div className="questionKey">{ question.num }</div>
        <div className="questionText">{ question.text }</div>
      </div>
      <label htmlFor={question.id} className='answered'>
        <div className="answer">
          <input id={question.id} type="radio" checked readOnly className="answer" />
          <span className="answerText">{ answer.text }</span>
        </div>
        <div className="answerLabel">{ answer.label }</div>
      </label>
    </div>
  );
};

const Workflow = ({
  findingId,
  answerQuestion,
  pendingAnswer,
  selectAnswer,
  workflow: { questions, type },
}) => {
  if (!questions[0]) {
    return <span />;
  }

  const question = getActiveQuestion(questions);
  const answeredQuestions = questions.filter(q => q.answered);
  const num = answeredQuestions.length + 1;

  return (
    <div className="workflow">
      { answeredQuestions.map((q, k) => (<AnsweredQuestion {...q} key={k} num={k + 1} />)) }
      <div className="question">
        <form>
          <div className={`questionRow ${pendingAnswer ? 'active' : ''}`}>
            <div className="questionKey">{ num }</div>
            <div className="questionText">{ question.text }</div>
          </div>
          {
            question.answers.map((answer, key) => {
              const customId = `${findingId}#${question.id}#${key + 1}`;
              // Adding debounce because when clicking on the label
              // a click event is bubbling down to the radio input as well
              // and two events are triggled. stopPropagation wouldn't work.
              return (
                <label htmlFor={customId} key={customId} onClick={debounce(() => selectAnswer({ answer }), 0)}>
                  <div className="answer">
                    <input name={question.id} id={customId} type="radio" className="answer" />
                    <span className="answerText">{ answer.text }</span>
                  </div>
                  <div className="answerLabel">{ answer.label }</div>
                </label>
              );
            })
          }
          {
            pendingAnswer &&
            <button
              className="submitAnswer"
              type="button"
              onClick={() => answerQuestion(question, type)}
            > { pendingAnswer.label || 'Submit Answer' }
            </button>
          }
        </form>
      </div>
    </div>
  );
};


const mapDispatchToProps = (dispatch, ownProps) => ({

  selectAnswer: ({ answer }) =>
    dispatch(updateField({
      id: ownProps.findingId,
      field: 'pendingAnswer',
      value: answer,
    })),

  answerQuestion: (question, type) => {
    dispatch(
      submitWorkflowQuestion({
        answerText: ownProps.pendingAnswer.text,
        findingId: ownProps.findingId,
        personId: window.settings.settings.user.id,
        questionId: question.id,
        type,
      })
    );
  },
});

export default connect(false, mapDispatchToProps)(Workflow);



// WEBPACK FOOTER //
// ./src/views/Components/Finding/Workflow/index.js